import { RecordStore, VoidCallback } from '@deqo/foundation';
import { EventRouter, TopicData, TopicValues } from '@deqo/podopolis';
import { Hangout } from './Hangout';
import { HangoutClient } from './HangoutClient';

export class HangoutTopic extends RecordStore({} as TopicData) {

    private ready = false;
    private router = new EventRouter<{
        ready: [],
        broadcast: [HangoutClient, string, any],
    }>();

    constructor(public readonly name: string, private hangout: Hangout, onDestroy: VoidCallback) {
        super();
        this.burden(
            onDestroy,
            hangout.on('topicBroadcast', ([client, target, type, data]) => {
                if (target === name) {
                    this.router.emit('broadcast', [client, type, data]);
                }
            }),
            hangout.on('topicUpdate', ([_client, target, data]) => {
                if (target === name) {
                    if (!this.ready) {
                        this.ready = true;
                        this.router.emit('ready', []);
                    }
                    this.setState(data);
                }
            }),
            this.router,
        );
    }

    public async waitForReady(): Promise<void> {
        await this.hangout.waitForReady();
        if (this.ready) return Promise.resolve();
        return new Promise((rs) => this.router.once('ready', () => {
            rs();
        }));
    }

    public async broadcast(type: string, data: any = {}) {
        await this.waitForReady();
        const pod = this.hangout.getPod();
        if (!pod) return false;
        pod.broadcastTopic(this.name, [type, data]);
        return true;
    }

    public async patch(values: TopicValues) {
        await this.waitForReady();
        const pod = this.hangout.getPod();
        if (!pod) return false;
        this.setState(pod.patchTopic(this.name, values));
        return true;
    }

    public receive(broadcastType: string, callback: (sender: HangoutClient, body: any) => void) {
        return this.router.on('broadcast', ([sender, type, data]) => {
            if (broadcastType === type) {
                callback(sender, data);
            }
        });
    }
}
